function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
export { _getPrototypeOf as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/getPrototypeOf.js
// module id = K0Ha
// module chunks = 0